import { isPlatformBrowser } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StoreService } from './store.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authPages = ['/sign-in', '/sign-up', '/forget-password', '/verify-account'];

  constructor(
    private injector: Injector,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hadAuthToken = req.headers.has('X-Access-Token') || req.headers.has('Authorization');
    // Loyalty endpoints 401 whenever a user simply hasn't joined the programme yet -
    // that's expected and must not tear down the whole app session.
    const isLoyaltyRequest = req.url.indexOf('/loyalty/') !== -1;

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!isLoyaltyRequest && isPlatformBrowser(this.platformId) && this.isSessionInvalid(error, hadAuthToken)) {
          this.forceLogout();
        }
        return throwError(error);
      })
    );
  }

  private isSessionInvalid(error: HttpErrorResponse, hadAuthToken: boolean): boolean {
    if (!error) {
      return false;
    }
    if (error.status === 403 || (error.status === 401 && hadAuthToken)) {
      return true;
    }
    return error.status === 400 && error.error && typeof error.error.message === 'string' &&
      error.error.message.toLowerCase().indexOf('token has been expired') !== -1;
  }

  private forceLogout(): void {
    const store = this.injector.get(StoreService);
    const router = this.injector.get(Router);
    store.saveLoginData({isLogged: false});

    const currentUrl = (router.url || '').split('?')[0];
    if (!this.authPages.some(page => currentUrl.indexOf(page) === 0)) {
      router.navigateByUrl('sign-in');
    }
  }
}
